import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";

// Pages load on first visit, so the app starts fast.
const Dashboard = lazy(() => import("./web/Dashboard.js").then((m) => ({ default: m.Dashboard })));
const ProjectPage = lazy(() => import("./web/ProjectPage.js").then((m) => ({ default: m.ProjectPage })));
const TemplatesPage = lazy(() => import("./web/AdminPages.js").then((m) => ({ default: m.TemplatesPage })));
const SettingsPage = lazy(() => import("./web/AdminPages.js").then((m) => ({ default: m.SettingsPage })));

export default defineWebModule({
  manifest,
  pages: {
    "": Dashboard,
    "/project": ProjectPage,
    "/templates": TemplatesPage,
    "/settings": SettingsPage,
  },
});
